import { createFetcherReducer } from '../utils';
import { LOADING_EXTRAS, RECEIVED_EXTRAS, RECEIVED_EXTRAS_FAILED } from '../../actions/types';

export default createFetcherReducer(
  LOADING_EXTRAS, RECEIVED_EXTRAS, RECEIVED_EXTRAS_FAILED,
);
